/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { convertObjectToQueryString, createRequestObject, getUserTokenData, getAPIMUrl } from '../utility/commonUtility';
import { deleteData, fetchData, postData, putData } from '@jda/lui-portal-utilities';
import { getAuthToken } from '../auth/authProvider';
import { ILocationType, LocationData } from '../models/Locations/Locations';

const { LOCATION_MANAGEMENT_SERVICE, REALM_METADATA_SERVICE, USER_MACHINE_SERVICE } = window['env'];

export const getLocations = async (queryParams: any): Promise<any> => {
  let queryData = '';
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${LOCATION_MANAGEMENT_SERVICE}/location`;

  if (queryParams && typeof queryParams === 'object') {
    queryData = convertObjectToQueryString(queryParams);
    apiURL = `${apiURL}?${queryData}`;
  }

  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const getLocationsBasedOnSubject = async (queryParams: any): Promise<any> => {
  let queryData = '';
  const subjectId: { sub: string } = await getUserTokenData();
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${USER_MACHINE_SERVICE}/users/${subjectId.sub}/locations`;
  if (queryParams && typeof queryParams === 'object') {
    queryData = convertObjectToQueryString(queryParams);
    apiURL = `${apiURL}?${queryData}`;
  }

  return fetchData<any>(createRequestObject(apiURL), getAuthToken).then(appsResponse => {
    return { data: appsResponse };
  }).catch((error: any) => {
    throw error;
  });
};

export const getLocationTypes = async () => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${REALM_METADATA_SERVICE}/locationType/supported`;

  return fetchData<{ data: ILocationType[] }>(createRequestObject(apiURL), getAuthToken).then(appsResponse => { return appsResponse?.data; });
};

export const createLocation = async (locationData: LocationData) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${LOCATION_MANAGEMENT_SERVICE}/location`;

  return postData<any>(createRequestObject(apiURL), locationData, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const getLocationById = async (locationId: any) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${LOCATION_MANAGEMENT_SERVICE}/location/${locationId}`; ///iam/locationManagement/v1/location'

  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      console.log('getLocationById location', appsResponse)
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const updateLocation = async (locationId: any, data: any) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${LOCATION_MANAGEMENT_SERVICE}/location/${locationId}`; ///iam/locationManagement/v1/location'
  return putData<any>(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const deleteLocation = async (locationId: any) => {
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${LOCATION_MANAGEMENT_SERVICE}/location/${locationId}`;
  return deleteData(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};